<template>
  <a @click="$emit('click')">メニュー</a>
</template>

<script>
// gaはglobal-header側で仕込む
export default {
  name: 'menu-button',
};
</script>
